// ===== K-Tec Language Detector =====
// Detects Sinhala, English, or Singlish from user input

export type Language = 'sinhala' | 'english' | 'singlish';

// Sinhala Unicode range: \u0D80-\u0DFF
const SINHALA_REGEX = /[\u0D80-\u0DFF]/;

// Singlish patterns - common romanized Sinhala words
const SINGLISH_PATTERNS = [
  /\b(mage|oyage|eka|tikak|eka|thiyenawa|thiyena|naha|oney|oni|oni|hadanna|danna|denna|kiyanna|balanna|wenawa|wena|gana|honda|hodai|api|mama|oya|eyaa|eya|harida|hari|neda|ne|da|do|gedi|gedera|gedarata|gedara|shop|ekata|office|warehouse|factory)\b/i,
  /\b(camera|cctv|ip|wifi|nvr|dvr|hdd|poe|cat6|alarm)\b.*\b(oni|oney|eka|tikak|hadanna|danna|kiyanna|oney)\b/i,
  /\b(budget|eka|tikak|thiyenawa|neda|honda|hoda|hari)\b/i,
];

const SINGLISH_WORDS = [
  'mage', 'oyage', 'api', 'mama', 'oya', 'eyaa', 'eya',
  'tikak', 'thiyenawa', 'thiyena', 'naha', 'oney', 'oni',
  'hadanna', 'danna', 'denna', 'kiyanna', 'balanna',
  'wenawa', 'wena', 'honda', 'hodai', 'hari', 'harida',
  'neda', 'ne', 'ekata', 'gedarata', 'gedara', 'gedera',
  'pennanna', 'pennanna', 'karanna', 'karala', 'kala',
  'budgeteka', 'budget eka', 'setup ekak', 'system ekak',
  'eka', 'ekak', 'thibuna', 'thibennawa', 'thiyena',
  'monawada', 'mokakda', 'kohomada', 'kohoma', 'keeyada',
  'keeya', 'kiyadak', 'rathriya', 'rathri', 'dawasa', 'dawasata',
];

export function detectLanguage(text: string): Language {
  // Check for Sinhala Unicode characters
  if (SINHALA_REGEX.test(text)) {
    // If also has Latin chars it's still primarily Sinhala
    return 'sinhala';
  }

  // Check for Singlish patterns
  const lower = text.toLowerCase();
  const words = lower.split(/\s+/);
  
  let singlishScore = 0;
  for (const word of words) {
    if (SINGLISH_WORDS.some(sw => word === sw || word.startsWith(sw))) {
      singlishScore++;
    }
  }
  
  // Check regex patterns
  for (const pattern of SINGLISH_PATTERNS) {
    if (pattern.test(lower)) {
      singlishScore += 2;
    }
  }

  if (singlishScore >= 1) return 'singlish';
  return 'english';
}

export function getLanguageLabel(lang: Language): string {
  switch (lang) {
    case 'sinhala': return 'සිංහල';
    case 'singlish': return 'Singlish';
    case 'english': return 'English';
  }
}
